import Vue from 'vue';
import VueRouter from 'vue-router';
import NotFound from "@/components/NotFound"
import NotAuthorized from "@/components/NotAuthorized"
import * as api from "./js/utils/api";

const ProjectsPage = () => import('@/views/ProjectsPage.vue')
const CompoundsPage = () => import('@/views/CompoundsPage.vue')
const LoginPage = () => import('@/views/LoginPage.vue')
const CompoundPage = () => import('@/views/CompoundPage.vue')
const ProjectPage = () => import('@/views/single_project/ProjectPage.vue')
const ResourcesPage = () => import('@/views/ResourcesPage.vue')
const VideoPage = () => import('@/views/VideoPage.vue')
const SubmissionsPage = () => import('@/views/SubmissionsPage.vue')
const AccountCreationPage = () => import('@/views/AccountCreationPage.vue')
const AccountConfirmationPage = () => import('@/views/AccountConfirmationPage.vue')
const PasswordResetRequestPage = () => import('@/views/PasswordResetRequestPage.vue')
const PasswordResetVerifiedPage = () => import('@/views/PasswordResetVerifiedPage.vue')
const SubmissionFormPage = () => import('@/views/SubmissionFormPage.vue')
const SubmissionInstructionPage = () => import('@/views/SubmissionInstructionPage.vue')
const DataAccessManagerPage = () => import('@/views/data_access_manager/DataAccessManagerPage.vue')

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        redirect: {name: 'ProjectsPage', path: '/projects/'}
    },
    {
        path: '/resources/',
        meta: {layout: "basic"},
        name: 'ResourcesPage',
        component: ResourcesPage
    },
    {
        path: '/data-access-manager/',
        meta: {layout: "sidebar"},
        name: 'DataAccessManagerPage',
        component: DataAccessManagerPage
    },
    {
        path: '/submissions/',
        meta: {layout: "basic"},
        name: 'SubmissionsPage',
        component: SubmissionsPage
    },
    {
        path: '/submissions/forms/:type/:screen',
        meta: {layout: "basic"},
        name: 'SubmissionFormPage',
        component: SubmissionFormPage
    },
    {
        path: '/submissions/instructions/:type/:agent',
        meta: {layout: "basic"},
        name: 'SubmissionInstructionPage',
        component: SubmissionInstructionPage
    },
    {
        path: '/resources/webinar/:title',
        meta: {layout: "basic"},
        name: 'VideoPage',
        component: VideoPage
    },
    {
        path: '/projects/',
        meta: {layout: "sidebar"},
        name: 'ProjectsPage',
        component: ProjectsPage
    },
    {
        path: '/projects/:screen',
        meta: {layout: "sidebar"},
        name: 'ProjectsPage',
        component: ProjectsPage
    },
    {
        path: '/compounds',
        meta: {layout: "sidebar"},
        name: 'CompoundsPage',
        component: CompoundsPage
    },
    {
        path: '/log-in',
        name: 'LoginPage',
        meta: {layout: "basic"},
        component: LoginPage
    },
    {
        path: '/account_creation',
        name: 'AccountCreationPage',
        meta: {layout: "basic"},
        component: AccountCreationPage
    },
    {
        path: '/account_confirmation/:token',
        name: 'AccountConfirmationPage',
        meta: {layout: "basic"},
        component: AccountConfirmationPage
    },
    {
        path: '/password_reset_request',
        name: 'PasswordResetRequestPage',
        meta: {layout: "basic"},
        component: PasswordResetRequestPage
    },
    {
        path: '/password_reset/:token',
        name: 'PasswordResetVerifiedPage',
        meta: {layout: "basic"},
        component: PasswordResetVerifiedPage
    },
    {
        path: '/notAuthorized',
        component: NotAuthorized
    },
    {
        path: '/projects/:screen/:project/:tab?',
        meta: {layout: "sidebar"},
        name: 'ProjectPage',
        component: ProjectPage,
        props: true
    },
    {
        path: '/:screen/:project/:pert_plate/:pert_id/:tab?/:subtab?',
        meta: {layout: "sidebar"},
        name: 'CompoundPage',
        component: CompoundPage,
        props: true
    },
    {
        path: "*",
        component: NotFound
    },
]


const router = new VueRouter({
    base: "portal",
    mode: 'history',
    routes: routes
})


router.beforeEach(async (to, from
        , next) => {
        let returnTo = "";
        if (to.query && to.query.returnTo && to.path && to.path === "/sso") {
            returnTo = to.query.returnTo
        }
        const url = process.env.VUE_APP_API_URL;
        const is_anonymous = await api.anonymousResources(to.fullPath, url);
        if (!localStorage.getItem('user_info') && (is_anonymous || to.fullPath === '/projects')) {
            const email = process.env.VUE_APP_ANONYMOUS_EMAIL;
            const pwd = process.env.VUE_APP_ANONYMOUS_PWD;
            await api.login(url, email.toLowerCase(), pwd);
            next();
        } else if (to.name !== 'LoginPage'
            && !localStorage.getItem('user_info')
            && to.name !== 'AccountCreationPage'
            && to.name !== 'AccountConfirmationPage'
            && to.name !== 'PasswordResetRequestPage'
            && to.name !== 'PasswordResetVerifiedPage'
            && to.name !== 'SubmissionsPage'
            && to.name !== 'SubmissionFormPage'
            && to.name !== 'SubmissionInstructionPage'
            && to.name !== 'DataAccessManagerPage'
        ) {
            if (returnTo) {
                next({name: 'LoginPage', query: {returnTo: returnTo}})
            } else {
                next({name: 'LoginPage', query: {redirect: to.fullPath}})
            }
        } else {
            if (returnTo && localStorage.getItem('user_info')) {
                const user_info = localStorage.getItem('user_info');
                const user_info_parsed = JSON.parse(user_info);
                if (user_info_parsed && user_info_parsed.api_key) {
                    window.location.assign(returnTo + "?jwt=" + user_info_parsed.api_key)
                    return;
                }
            }
            next()
        }
    }
)


router.afterEach((to) => {
    sendAnalyticsPageview(to);
});

const GA_MEASUREMENT_ID = 'G-1G9FWYFW6K';

function sendAnalyticsPageview(to) {
    // implemented following Google documentation
    // https://developers.google.com/analytics/devguides/collection/gtagjs/pages
    const pageInfo = {
        page_path: to.path,
        page_title: to.name
    }
    // eslint-disable-next-line
    gtag('config', GA_MEASUREMENT_ID, pageInfo);


}


export default router

